module.exports = {
    COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME || "Propio Language Services",
    COMPANY_URL: process.env.REACT_APP_COMPANY_URL || "https://propio.com",
};
